"use client";
// Imports
import Link from "next/link";
import { Img } from "@/components";
import { Button } from "@/components/ui/button";
import { resolveLink, cn } from "@/lib/utils";

function resolveBadge(ctaBadge) {
  if (!ctaBadge) return null;
  return Array.isArray(ctaBadge) ? ctaBadge[0] : ctaBadge;
}

// Red CTA strip under hero (badge + copy + button) — replaces countdown when enabled
export function HeroCtaBar({
  badge,
  title,
  text,
  buttonTitle,
  link,
}) {
  const badgeAsset = resolveBadge(badge);
  const href = resolveLink(link);
  const hasButton = Boolean(href && buttonTitle);
  const hasCopy = Boolean(title || text);

  if (!badgeAsset && !hasCopy && !hasButton) {
    return null;
  }

  return (
    <div className="w-full bg-brand-red-gum text-brand-wool animate-section-in">
      <div
        className={cn(
          "mx-auto w-full max-w-8xl px-4 py-4 sm:px-6 lg:px-10 lg:py-5",
          "flex flex-col gap-4 sm:gap-5",
          "lg:flex-row lg:items-center lg:justify-between lg:gap-8"
        )}
      >
        <div className="flex items-center gap-4 sm:gap-5 min-w-0 flex-1">
          {badgeAsset && (
            <div className="shrink-0 w-16 h-16 sm:w-20 sm:h-20 lg:w-24 lg:h-24 relative">
              <Img
                data={badgeAsset}
                fill
                sizes="96px"
                className="object-contain"
              />
            </div>
          )}
          {hasCopy && (
            <div className="min-w-0 flex-1">
              {title && (
                <p className="font-heading font-heading-sentence text-brand-wool text-base sm:text-lg lg:text-xl leading-tight">
                  {title}
                </p>
              )}
              {text && (
                <p className="font-body text-brand-wool/90 text-base sm:text-lg leading-snug mt-1 text-pretty">
                  {text}
                </p>
              )}
            </div>
          )}
        </div>

        {hasButton && (
          <div className="shrink-0 w-full sm:w-auto">
            <Button
              asChild
              customColors={{
                background: "#151515",
                foreground: "#FFFFFF",
              }}
              className="font-heading !uppercase tracking-normal w-full sm:w-auto h-11 px-6"
            >
              <Link href={href}>{buttonTitle}</Link>
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
